function ready(callback) {
  if (window.AlipayJSBridge) {
    callback && callback();
  } else {
    document.addEventListener('AlipayJSBridgeReady', callback, false);
  }
}

// 支付宝支付
export function aliPay(tradeNO) {
  return new Promise((resolve, reject) => {
    ready(function () {
      // 通过传入交易号唤起快捷调用方式(注意tradeNO大小写严格)
      window.AlipayJSBridge.call("tradePay", {
        tradeNO: tradeNO
      }, function (data) {
        if ("9000" == data.resultCode) {
          resolve(true)
        } else {
          reject(false)
        }
      });
    });
  })
}

// 获取支付宝code
export function getAliUserInfo() {
  return new Promise((resolve) => {
    let resolved = false;
    const finish = (authCode) => {
      if (resolved) return;
      resolved = true;
      resolve(authCode || false);
    };
    const getAuthCode = () => {
      if (!window.ap || !window.ap.getAuthCode) {
        return false;
      }

      window.ap.getAuthCode(
        {
          appId: '2021006156650889',
          scopes: ['auth_base'],
          showErrorTip: false,
        }, (res) => {
          if (res && res.authCode) {
            finish(res.authCode);
          } else {
            console.log('支付宝授权失败', JSON.stringify(res || {}));
            finish(false);
          }
        }
      )
      return true;
    };

    if (!getAuthCode()) {
      ready(getAuthCode);
    }
    setTimeout(() => finish(false), 5000);
  })
}
